import { Version } from '../Version.js';
export abstract class SpecialVersion extends Version {
  constructor(versionString: string) {
    super(versionString, 'special');
  }
}